import React from "react";

function ProtectedLayout({ component: Component, ...rest }) {
  const pageName = window.location.pathname.split("/")[1];
  const pages = [
    "reset-password",
    "privacy-policy",
    "terms-and-conditions",
    "new-password",
    "how-to-stream",
    "streamChat"
  ];
  if (pages.includes(pageName)) return null;
  else return <Component {...rest} />;
}

export default ProtectedLayout;
 